module.exports = __webpack_public_path__ + "img/file_upload.00b2df1c.png";